import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag, ArrowRight } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { fcfa, PLACEHOLDER_IMG } from "../../lib/format";
import { ShopHeader } from "../../components/shop/ShopHeader";
import { ShopFooter } from "../../components/shop/ShopFooter";

export default function Cart() {
  const { items, updateQty, removeItem, total } = useCart();
  const navigate = useNavigate();

  return (
    <div className="App overflow-x-hidden min-h-screen flex flex-col">
      <ShopHeader />
      <div className="flex-1 w-full max-w-md mx-auto sm:max-w-4xl px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="font-heading text-3xl font-black tracking-tight text-brand-ink mb-6">Mon panier</h1>

        {items.length === 0 ? (
          <div className="bg-white border border-brand-line rounded-2xl p-12 text-center">
            <ShoppingBag className="w-12 h-12 text-brand-muted mx-auto mb-4" />
            <p className="text-brand-muted">Votre panier est vide.</p>
            <Link to="/boutique" data-testid="continue-shopping" className="mt-6 inline-block bg-brand text-white hover:bg-brand-hover transition-colors rounded-full px-6 py-3 font-semibold">
              Découvrir les produits
            </Link>
          </div>
        ) : (
          <div className="space-y-4">
            {items.map((item) => (
              <div key={item.product_id} data-testid={`cart-item-${item.product_id}`} className="bg-white border border-brand-line rounded-2xl p-4 flex items-center gap-4">
                <img src={item.image_url || PLACEHOLDER_IMG} alt={item.name} className="w-16 h-16 rounded-xl object-cover bg-brand-cream" />
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-semibold text-brand-ink truncate">{item.name}</h3>
                  <p className="text-sm text-brand-muted">{fcfa(item.price)}</p>
                </div>
                <div className="flex items-center border border-brand-line rounded-full">
                  <button onClick={() => updateQty(item.product_id, item.qty - 1)} className="p-2 hover:bg-brand-cream rounded-full"><Minus className="w-3.5 h-3.5" /></button>
                  <span className="w-8 text-center text-sm font-semibold">{item.qty}</span>
                  <button onClick={() => updateQty(item.product_id, item.qty + 1)} className="p-2 hover:bg-brand-cream rounded-full"><Plus className="w-3.5 h-3.5" /></button>
                </div>
                <div className="text-right w-24 hidden sm:block font-semibold text-brand-ink">{fcfa(item.price * item.qty)}</div>
                <button onClick={() => removeItem(item.product_id)} data-testid={`remove-${item.product_id}`} className="p-2 text-brand-secondary hover:bg-red-50 rounded-full"><Trash2 className="w-4 h-4" /></button>
              </div>
            ))}

            <div className="bg-white border border-brand-line rounded-2xl p-6 mt-6">
              <div className="flex justify-between items-center mb-4">
                <span className="text-brand-sub">Total</span>
                <span data-testid="cart-total" className="font-heading font-black text-2xl text-brand-ink">{fcfa(total)}</span>
              </div>
              <button onClick={() => navigate("/commander")} data-testid="checkout-button" className="w-full bg-brand text-white hover:bg-brand-hover transition-colors rounded-full px-6 py-3.5 font-semibold flex items-center justify-center gap-2">
                Commander <ArrowRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        )}
      </div>
      <ShopFooter />
    </div>
  );
}
